
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contribute",
      function () {
        return require("private-next-pages/contribute.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contribute"])
      });
    }
  